export const DIMENSION = {
  Desktop: 'desktop',
  Tablet: 'tablet',
  Mobile: 'mobile',
};

export const LAYOUT = {
  Fluid: 'fluid',
  Boxed: 'boxed',
};

export const RADIUS = {
  Rounded: 'rounded',
  Standard: 'standard',
  Flat: 'flat',
};

export const THEME_COLOR = {
  LightBlue: 'light-blue',
  DarkBlue: 'dark-blue',
  LightRed: 'light-red',
  DarkRed: 'dark-red',
  LightGreen: 'light-green',
  DarkGreen: 'dark-green',
  LightPurple: 'light-purple',
  DarkPurple: 'dark-purple',
  LightPink: 'light-pink',
  DarkPink: 'dark-pink',
};

export const NAV_COLOR = {
  Default: 'default',
  Light: 'light',
  Dark: 'dark',
};
export const MENU_PLACEMENT = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
};
export const MENU_BEHAVIOUR = {
  Pinned: 'pinned',
  Unpinned: 'unpinned',
};

export const USER_ROLE = {
  Admin: 'admin',
  Editor: 'editor',
};
export const CORE_COMPANY = 'DANUBEHOMEONLINE';
export const COUNTRIES = [
  {
    id: 'uae',
    code: 'UAE',
    value: 'uae',
    label: 'UAE',
    iso2_code: 'AE',
    flag: '🇦🇪',
    currency: 'AED',
  },
  {
    id: 'qat',
    code: 'QAT',
    value: 'qat',
    label: 'QAT',
    iso2_code: 'QA',
    flag: '🇶🇦',
    currency: 'QAR',
  },
  {
    id: 'bah',
    code: 'BAH',
    value: 'bah',
    label: 'BAH',
    iso2_code: 'BH',
    flag: '🇧🇭',
    currency: 'BHD',
  },
  {
    id: 'omn',
    code: 'OMN',
    value: 'omn',
    label: 'OMN',
    iso2_code: 'OM',
    flag: '🇴🇲',
    currency: 'OMR',
  },
  {
    id: 'ksa',
    code: 'KSA',
    value: 'ksa',
    label: 'KSA',
    iso2_code: 'SA',
    flag: '🇸🇦',
    currency: 'SAR',
  },
  {
    id: 'kwt',
    code: 'KWT',
    value: 'kwt',
    label: 'KWT',
    iso2_code: 'KW',
    flag: '🇰🇼',
    currency: 'KWD',
  },
];
export const WAREHOUSES = {
  UAE: [
    { id: 'uae_jebel_ali', name: 'Jebel Ali' },
    { id: 'uae_jafza', name: 'Jafza' },
  ],
  QAT: [
    { id: 'qat_jebel_ali', name: 'Jebel Ali' },
    { id: 'qat_jafza', name: 'Jafza' },
  ],
  OMN: [
    { id: 'OMN_jebel_ali', name: 'Jebel Ali' },
    { id: 'OMN_jafza', name: 'Jafza' },
  ],
  BAH: [
    { id: 'BAH_jebel_ali', name: 'Jebel Ali' },
    { id: 'BAH_jafza', name: 'Jafza' },
  ],
  KSA: [
    { id: 'BAH_jebel_ali', name: 'Jebel Ali' },
    { id: 'BAH_jafza', name: 'Jafza' },
  ],
  KWT: [
    { id: 'BAH_jebel_ali', name: 'Jebel Ali' },
    { id: 'BAH_jafza', name: 'Jafza' },
  ],
};

export const MARKETPLACES = [
  { id: 'DanubeHome', name: 'DANUBE HOMES', logo: 'https://cdn.danubehome.com/media/logo/stores/1/Online-Logo_02.jpg' },
  { id: 'Houzz', name: 'Houzz', logo: 'https://1000logos.net/wp-content/uploads/2017/08/Houzz-Logo.png' },
];

export const SORTING_ORDER = {
  ASC: 1,
  DESC: -1,
};

export const INPUT = {
  SELECT: 'select',
  TEXT: 'text',
  BOOLEAN: 'boolean',
  PRICE: 'price',
  TEXTAREA: 'textarea',
  DATE: 'date',
  NUMERIC: 'numeric',
};

export const SELLER_ONBOARDING = {
  REG_EXP_ALPHABETS: /^[a-zA-Z ]*$/,
  REG_EXP_DIGITS: /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
  REG_EXP_UAE_PHONE_NO: /^(?:\+971|971|0)?(?:50|51|52|54|55|56|57|58|2|3|4|6|7|8|9)\d{7}$/,
  DEFAULT_COUNTRY: 'AE',
};

export const OMS_API = {
  // BASE_URL: 'http://localhost/dh-seller/public/api/v1'
  // BASE_URL: 'http://172.18.2.204/dh-seller/public/api/v1/'
  BASE_URL: process.env.SELLER_HUB_ORDERS_BASE_API,
  // 'https://dhsellerjnk.danubehome.com/api/v1',
};

// export const STATUS_COLOR = {
//   Pending: 'muted',
//   Accepted: 'primary',
//   Readytopickup: 'info',
//   Picked: 'quaternary',
//   Delivered: 'tertiary',
//   Return: 'danger',
//   Reject: 'danger',
//   Invoicepending: 'warning',
//   Completed: 'success',
//   PartiallyAccepted: 'info',
// };
export const STATUS_CUSTOMER_CANCELLED = 100;

export const STATUS_COLOR = [
  {
    lsStatus: 'Pending',
    color: 'light-badge-muted',
    id: '0',
  },
  {
    lsStatus: 'Accepted',
    color: 'light-badge-primary',
    id: '1',
  },
  {
    lsStatus: 'Ready to pickup',
    color: 'light-badge-info',
    id: '2',
  },
  {
    lsStatus: 'Picked',
    color: 'light-badge-progress',
    id: '3',
  },
  {
    lsStatus: 'Delivered',
    color: 'light-badge-success',
    id: '4',
  },
  {
    lsStatus: 'Un Delivered',
    color: 'light-badge-danger',
    id: '10',
  },
  {
    lsStatus: 'Delivery Failed',
    color: 'light-badge-danger',
    id: '12',
  },
  {
    lsStatus: 'Return',
    color: 'light-badge-danger',
    id: '5',
  },
  {
    lsStatus: 'Reject',
    color: 'light-badge-danger',
    id: '6',
  },
  {
    lsStatus: 'Invoice pending',
    color: 'light-badge-warn',
    id: '9',
  },
  {
    lsStatus: 'Completed',
    color: 'light-badge-success',
    id: '8',
  },
  {
    lsStatus: 'Partially Accepted',
    color: 'info',
    id: '7',
  },
  {
    lsStatus: 'Cancelled by Customer',
    color: 'light-badge-danger',
    id: STATUS_CUSTOMER_CANCELLED,
  },
  {
    lsStatus: 'Cancelled by Seller',
    color: 'danger',
    id: '6',
  },
  {
    lsStatus: 'Out for Delivery',
    color: 'light-badge-info',
    id: '11',
  },
];

export const SERVER_URL = {
  BASE_URL: 'http://localhost:4002',
};

export const IMPORT_STATUS = {
  Success: 'Success',
  Failed: 'Failed',
};

export const APPROVAL_STATUS = {
  APPROVAL_PENDING: 'APPROVAL_PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
  QC_ASSIGNED: 'QC_ASSIGNED',
  ATTRIBUTE_QC_PENDING: 'ATTRIBUTE_QC_PENDING',
  ATTRIBUTE_QC_ASSIGNED: 'ATTRIBUTE_QC_ASSIGNED',
  ATTRIBUTE_QC_REJECTED: 'ATTRIBUTE_QC_REJECTED',
};
export const SELLER_APPROVED_VALUES = [
  { value: 1, label: 'Permanently Blocked' },
  { value: 2, label: 'Active' },
  { value: 3, label: 'Temporarily Suspended' },
  { value: 4, label: 'Onboarding Verification' },
  { value: 5, label: 'Catalog Suspended' },
];
export const DAY_VALUES = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

export const OFFER_OPTIONS = [
  { value: 'default', label: 'MSP' },
  { value: 'sale', label: 'Sale Price' },
  // { value: 'further_reduction', label: 'Further Reduction' },
  // { value: 'lightening', label: 'Lightening Deal' },
];

export const CUSTOMER_OPTIONS = [
  { value: 'all', label: 'All Customers' },
  // { value: 'vip', label: 'VIP Customers' },
];

export const DEFAULT_CUSTOMER_GROUP = 'all';

export const DEFAULT_OFFER_ID = 'default';
export const OFFER_SALE_ID = 'sale';

export const DEFAULT_COUNTRY = 'AE';
export const DEFAULT_CURRENCY = 'AED';

// Countries a marketplace seller may not price from the product detail Pricing
// tab. Oman prices are derived downstream (the import fee is applied at index
// time for export sellers), so a seller must not edit them by hand.
// CORE_COMPANY is exempt - it manages these prices.
export const PRICE_LOCKED_COUNTRIES = ['OM'];

export const DEFAULT_PRICE_RANGE = [0, 100000];

export const STATUS_PENDING = 0;
export const STATUS_ACCEPTED = 1;
export const STATUS_DELIVERED = 4;
export const STATUS_READY_TO_PICKUP = 2;
export const STATUS_PICKED = 3;
export const STATUS_REJECT = 6;
export const STATUS_UNDELIVERED = 10;
export const STATUS_OUT_FOR_DELIVERY = 11;
export const STATUS_ALL = 20;

// Made to order - customer review of the product images captured by the seller
export const CUSTOMER_REVIEW_PENDING = 'pending';
export const CUSTOMER_REVIEW_APPROVED = 'approved';
export const CUSTOMER_REVIEW_REJECTED = 'rejected';
export const ADMIN_REVIEW_PENDING = 'pending';
export const ADMIN_REVIEW_REJECTED = 'rejected';
export const CUSTOMER_REVIEW_ACTION_ENABLE_PROCESSING = 'enable_processing';
export const CUSTOMER_REVIEW_MIN_IMAGES = 1;
export const CUSTOMER_REVIEW_MAX_IMAGES = 5;

export const COMMENT_DISPLAY_DATE_FORMAT = 'DD MMM YYYY h:m a';

export const BASE_ID_RELATED_BY = [
  { label: 'Color', value: 'color' },
  { label: 'Mattress Size', value: 'mattress_size' },
  { label: 'Pattern Size', value: 'pattern_size' },
  { label: 'Carpet Size', value: 'carpet_size' },
  { label: 'Number of Doors', value: 'no_of_doors' },
  { label: 'Seating Capacity', value: 'seating_capacity' },
  { label: 'Grass Carpet Thickness', value: 'grass_carpet_thickness' },
];

export const SUPPORT_TICKET_STATUS = ['opened', 'pending', 'reopened', 'resolved', 'cancellation / returns', 'escalated'];
export const SUPPORT_TICKET_STATUS_BG = {
  opened: { bg: 'info', subTitle: 'New' },
  pending: { bg: 'info', subTitle: 'Working On' },

  resolved: { bg: 'quaternary' },
  duplicate: { bg: 'muted' },
  'cancellation / returns': { bg: 'success' },
  escalated: { bg: 'danger' },
  reopened: { bg: 'warning', subTitle: '' },
};

export const ACCOUNT_HEALTH_WEIGHTAGE = {
  delayed_acceptance: 2,
  delayed_message_reply: 3,
  delayed_support_ticket_resolution: 2,
  track_sheet_missed: 3,
  breached_delivery_date: 2,
  order_rejection: 3,
  order_defect: 3,
  late_pod_upload: 1,
  late_invoice_upload: 1,
  product_not_as_described: 3,
  product_negative_comments: 2,
  product_negative_ratings: 2,
  delivery_negative_ratings: 2,
  seller_negative_ratings: 2,
  danube_gaurantee_claims: 2,
  other_process_voilation: 2,
  total: 35,
};

export const EXPORT_SELLER_GROUP = 'DANUBEWORLD';
